import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { OneModal } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

interface Props {
  title: string
  message: string
  open: boolean
  onClose: () => void
  onConfirm: () => void
  loading?: boolean
}

export const DeleteModal = ({
  title,
  message,
  open,
  onClose,
  onConfirm,
  loading = false,
}: Props) => {
  return (
    <OneModal isOpen={open} onClose={onClose}>
      <OneModal.Header title={title} />
      <OneModal.Content withPadding>
        <Box gap="s12">
          <Text.Normal>{message}</Text.Normal>
        </Box>
      </OneModal.Content>
      <OneModal.Footer>
        <Box flexDirection="row" gap="s8" justifyContent="flexEnd" width="full">
          <F0Button
            onClick={onClose}
            label={i18n.t('complaints.delete_modal.cancel')}
            variant="outline"
            disabled={loading}
          />
          <F0Button
            onClick={onConfirm}
            label={
              loading
                ? i18n.t('complaints.delete_modal.deleting')
                : i18n.t('complaints.delete_modal.delete')
            }
            variant="default"
            disabled={loading}
            loading={loading}
          />
        </Box>
      </OneModal.Footer>
    </OneModal>
  )
}
